import {
    getKpiGetProgress,
    getKpiGetSalaryToPay,
    getSchedulerPointScheduleDetails,
    thunkCall,
} from "tm-shared/api";

export const getSchedulerPointScheduleDetailsManagerThunk = thunkCall(
    "getSchedulerPointScheduleDetailsSv",
    getSchedulerPointScheduleDetails,
);

export const getKpiGetProgressSvThunk = thunkCall(
    "getKpiGetProgressSv",
    getKpiGetProgress,
);

export const getKpiGetSalaryToPaySvThunk = thunkCall(
    "getKpiGetSalaryToPaySv",
    getKpiGetSalaryToPay,
);
